import { UserID } from "./User";

export type ExportEventID = number;

export interface ExportEvent {
  created_on: string;
  updated_on: string;
  id: ExportEventID; // Identifier of the exported event
  user_id: UserID; // Identifier of the user that created the export
  url: string; // URL of the export
  error: string; // Error message
}
